import React from 'react';
import { useSelector } from 'react-redux';
import { ArrowForward } from '@yme/assets/icons';
import { BTN_DARK_THEME, CONTAINED_VARIANT, SIZE_44, TRAILING_ICON, Button, } from '@yme/atoms/button';
import { ShowMore } from '@yme/atoms/show-more';
import { getHeaderStickyMenuShown } from '@yme/components/Header/redux/selectors';
import { IndentWrapper } from '@yme/components/Separator';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { HeroSectionContentPage } from '@yme/organisms/hero-section';
import { getPageBlockStrategy, getRTL } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { scrollToId, selectColorTheme } from '@yme/utils/common';
import { AMOUNT_OF_MOBILE_HEIGHT_MENU, TEST_RIDE_GRID_WRAPPER } from './constants';
import { DescriptionStyled, ShowMoreWrapperStyled } from './styled';
export function TestRideHeroSection(props) {
    const { isRemoveBottomIndent, labels, backgroundImage } = props;
    const { t } = useTranslation();
    const { isMobileView } = useWindowSize();
    const pageBlockStrategy = useSelector(getPageBlockStrategy);
    const headerStickyMenuShown = useSelector(getHeaderStickyMenuShown);
    const isRightToLeft = useSelector(getRTL);
    const blockStrategy = selectColorTheme(pageBlockStrategy?.toLowerCase());
    const yOffset = !headerStickyMenuShown
        ? AMOUNT_OF_MOBILE_HEIGHT_MENU * 2
        : AMOUNT_OF_MOBILE_HEIGHT_MENU;
    const onScrollToIdHandler = () => {
        scrollToId({
            id: TEST_RIDE_GRID_WRAPPER,
            yOffset,
        });
    };
    if (!labels || !backgroundImage) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement("section", null,
            React.createElement(HeroSectionContentPage, { title: labels?.testRideHeroSection_requestTestRide_header, description: labels?.testRideHeroSection_selectModelBelow_description, backgroundImage: backgroundImage, isRightToLeft: isRightToLeft, hasSelectorPanel: true }),
            labels?.testRideHeroSection_selectModelBelow_description && isMobileView && (React.createElement(DescriptionStyled, { blockStrategy: blockStrategy, gap: "12px", alignItems: "center", flexDirection: "column", isFullWidth: true },
                React.createElement(ShowMore, { maxLinesCount: 3, labelShowLess: t('common_showLess_button'), labelShowMore: t('common_showMore_button'), textColor: colorCoreWhite1000, wrapper: ShowMoreWrapperStyled, buttonColor: colorCoreWhite1000 }, labels?.testRideHeroSection_selectModelBelow_description),
                React.createElement(Button, { label: t('common_learnMore_link'), buttonVariant: CONTAINED_VARIANT, hasIconButton: TRAILING_ICON, size: SIZE_44, colorSchema: BTN_DARK_THEME, iconComponent: ArrowForward, iconRotate: 90, onClick: onScrollToIdHandler }))))));
}
TestRideHeroSection.displayName = 'TestRideHeroSection_AEMComponent';
